// // // components/LocationSection.tsx
// // import React, { useState } from 'react';
// // import { ChevronDown, ChevronRight, MapPin } from 'react-feather';
// // import SimpleLocationMap from './simplemap';

// // // Define types for the props
// // interface Location {
// //   latitude: number | null;
// //   longitude: number | null;
// // }

// // interface LocationSectionProps {
// //   checkInLocation: Location | null | undefined;
// //   checkOutLocation: Location | null | undefined;
// //   checkInTime?: string | null;
// //   checkOutTime?: string | null;
// // }

// // const LocationSection: React.FC<LocationSectionProps> = ({ 
// //   checkInLocation, 
// //   checkOutLocation, 
// //   checkInTime, 
// //   checkOutTime 
// // }) => {
// //   const [isExpanded, setIsExpanded] = useState<boolean>(false);
  
// //   const hasLocation = (checkInLocation?.latitude && checkInLocation?.longitude) ||
// //                      (checkOutLocation?.latitude && checkOutLocation?.longitude);

// //   if (!hasLocation) return null;

// //   const toggleExpand = () => setIsExpanded(!isExpanded);

// //   return (
// //     <div className="mt-2">
// //       <div 
// //         className="p-2 bg-light rounded cursor-pointer d-flex align-items-center justify-content-between"
// //         onClick={toggleExpand}
// //         style={{ cursor: 'pointer' }}
// //       >
// //         <div className="d-flex align-items-center gap-2">
// //           <MapPin size={16} className="text-primary" />
// //           <div>
// //             <small className="text-muted">Location</small>
// //             <div className="d-flex gap-1 mt-1">
// //               {checkInLocation?.latitude && (
// //                 <span className="badge bg-success">Check-in</span>
// //               )}
// //               {checkOutLocation?.latitude && (
// //                 <span className="badge bg-danger">Check-out</span>
// //               )}
// //             </div>
// //           </div>
// //         </div>
// //         {isExpanded ? (
// //           <ChevronDown size={18} className="text-muted" />
// //         ) : (
// //           <ChevronRight size={18} className="text-muted" />
// //         )}
// //       </div>
      
// //       {isExpanded && (
// //         <div className="mt-2">
// //           {/* Show check-in location if available */}
// //           {checkInLocation?.latitude && checkInLocation?.longitude && (
// //             <SimpleLocationMap
// //               latitude={checkInLocation.latitude}
// //               longitude={checkInLocation.longitude}
// //               label={`Check-in${checkInTime ? ` (${checkInTime})` : ''}`}
// //             />
// //           )}

// //           {/* Show check-out location if available and different from check-in */}
// //           {checkOutLocation?.latitude && 
// //            checkOutLocation?.longitude && 
// //            checkInLocation?.latitude && 
// //            checkInLocation?.longitude && 
// //            (checkOutLocation.latitude !== checkInLocation.latitude ||
// //             checkOutLocation.longitude !== checkInLocation.longitude) && (
// //             <div className="mt-2">
// //               <SimpleLocationMap
// //                 latitude={checkOutLocation.latitude}
// //                 longitude={checkOutLocation.longitude}
// //                 label={`Check-out${checkOutTime ? ` (${checkOutTime})` : ''}`}
// //               />
// //             </div>
// //           )}

// //           {/* If only check-out has location */}
// //           {checkOutLocation?.latitude && 
// //            checkOutLocation?.longitude && 
// //            !checkInLocation?.latitude && (
// //             <SimpleLocationMap
// //               latitude={checkOutLocation.latitude}
// //               longitude={checkOutLocation.longitude}
// //               label={`Check-out${checkOutTime ? ` (${checkOutTime})` : ''}`}
// //             />
// //           )}

// //           {/* If only check-in has location (no check-out) */}
// //           {checkInLocation?.latitude && 
// //            checkInLocation?.longitude && 
// //            !checkOutLocation?.latitude && (
// //             <div className="mt-2">
// //               <SimpleLocationMap
// //                 latitude={checkInLocation.latitude}
// //                 longitude={checkInLocation.longitude}
// //                 label={`Check-in${checkInTime ? ` (${checkInTime})` : ''}`}
// //               />
// //             </div>
// //           )}
// //         </div>
// //       )}
// //     </div>
// //   );
// // };

// // export default LocationSection;

// // components/LocationSection.tsx
// import React, { useState } from 'react';
// import { ChevronDown, ChevronRight, MapPin } from 'react-feather';
// import SimpleLocationMap from './simplemap';

// // Define types for the props
// interface Location {
//   latitude: number | null;
//   longitude: number | null;
// }

// interface LocationSectionProps {
//   checkInLocation: Location | null | undefined;
//   checkOutLocation: Location | null | undefined;
//   checkInTime?: string | null;
//   checkOutTime?: string | null;
//   showRadius?: boolean;
//   radius?: number;
// }

// const LocationSection: React.FC<LocationSectionProps> = ({ 
//   checkInLocation, 
//   checkOutLocation, 
//   checkInTime, 
//   checkOutTime,
//   showRadius = false,
//   radius = 100,
// }) => {
//   const [isExpanded, setIsExpanded] = useState<boolean>(false);
  
//   const hasLocation = (checkInLocation?.latitude && checkInLocation?.longitude) ||
//                      (checkOutLocation?.latitude && checkOutLocation?.longitude);

//   if (!hasLocation) return null;

//   const toggleExpand = () => setIsExpanded(!isExpanded);

//   // Check if two locations are different
//   const areLocationsDifferent = (loc1: Location | null | undefined, loc2: Location | null | undefined) => {
//     if (!loc1 || !loc2) return false;
//     if (!loc1.latitude || !loc1.longitude || !loc2.latitude || !loc2.longitude) return false;
//     return loc1.latitude !== loc2.latitude || loc1.longitude !== loc2.longitude;
//   };

//   return (
//     <div className="mt-2">
//       <div 
//         className="p-2 bg-light rounded cursor-pointer d-flex align-items-center justify-content-between"
//         onClick={toggleExpand}
//         style={{ cursor: 'pointer' }}
//       >
//         <div className="d-flex align-items-center gap-2">
//           <MapPin size={16} className="text-primary" />
//           <div>
//             <small className="text-muted">Location</small>
//             <div className="d-flex gap-1 mt-1">
//               {checkInLocation?.latitude && (
//                 <span className="badge bg-success">Check-in</span>
//               )}
//               {checkOutLocation?.latitude && (
//                 <span className="badge bg-danger">Check-out</span>
//               )}
//             </div>
//           </div>
//         </div>
//         {isExpanded ? (
//           <ChevronDown size={18} className="text-muted" />
//         ) : (
//           <ChevronRight size={18} className="text-muted" />
//         )}
//       </div>
      
//       {isExpanded && (
//         <div className="mt-2">
//           {/* Show check-in location if available */}
//           {checkInLocation?.latitude && checkInLocation?.longitude && (
//             <SimpleLocationMap
//               latitude={checkInLocation.latitude}
//               longitude={checkInLocation.longitude}
//               label={`Check-in${checkInTime ? ` (${checkInTime})` : ''}`}
//               showRadius={showRadius}
//               radius={radius}
//             />
//           )}

//           {/* Show check-out location if available and different from check-in */}
//           {checkOutLocation?.latitude && 
//            checkOutLocation?.longitude && 
//            checkInLocation?.latitude && 
//            checkInLocation?.longitude && 
//            areLocationsDifferent(checkInLocation, checkOutLocation) && (
//             <div className="mt-2">
//               <SimpleLocationMap
//                 latitude={checkOutLocation.latitude}
//                 longitude={checkOutLocation.longitude}
//                 label={`Check-out${checkOutTime ? ` (${checkOutTime})` : ''}`}
//                 showRadius={showRadius}
//                 radius={radius}
//               />
//             </div>
//           )}

//           {/* If only check-out has location */}
//           {checkOutLocation?.latitude && 
//            checkOutLocation?.longitude && 
//            !checkInLocation?.latitude && (
//             <SimpleLocationMap
//               latitude={checkOutLocation.latitude}
//               longitude={checkOutLocation.longitude}
//               label={`Check-out${checkOutTime ? ` (${checkOutTime})` : ''}`}
//               showRadius={showRadius}
//               radius={radius}
//             />
//           )}

//           {/* If only check-in has location (no check-out) */}
//           {checkInLocation?.latitude && 
//            checkInLocation?.longitude && 
//            !checkOutLocation?.latitude && (
//             <div className="mt-2">
//               <SimpleLocationMap
//                 latitude={checkInLocation.latitude}
//                 longitude={checkInLocation.longitude}
//                 label={`Check-in${checkInTime ? ` (${checkInTime})` : ''}`}
//                 showRadius={showRadius}
//                 radius={radius}
//               />
//             </div>
//           )}
//         </div>
//       )}
//     </div>
//   );
// };

// export default LocationSection;

// components/LocationSection.tsx
import React, { useState } from 'react';
import { ChevronDown, ChevronRight, MapPin } from 'react-feather';
import SimpleLocationMap from './simplemap';

// Define types for the props
interface Location {
  latitude: number | null;
  longitude: number | null;
}

interface LocationSectionProps {
  checkInLocation: Location | null | undefined;
  checkOutLocation: Location | null | undefined;
  checkInTime?: string | null;
  checkOutTime?: string | null;
  showRadius?: boolean;
  radius?: number;
}

const LocationSection: React.FC<LocationSectionProps> = ({ 
  checkInLocation, 
  checkOutLocation, 
  checkInTime, 
  checkOutTime,
  showRadius = false,
  radius = 100,
}) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  
  // Check if check-in has valid location
  const hasCheckInLocation = !!(checkInLocation?.latitude && checkInLocation?.longitude);
  // Check if check-out has valid location
  const hasCheckOutLocation = !!(checkOutLocation?.latitude && checkOutLocation?.longitude);
  
  // Only show if at least one location exists
  const hasLocation = hasCheckInLocation || hasCheckOutLocation;

  if (!hasLocation) return null;

  const toggleExpand = () => setIsExpanded(!isExpanded);

  // Check if two locations are different
  const areLocationsDifferent = (loc1: Location | null | undefined, loc2: Location | null | undefined) => {
    if (!loc1 || !loc2) return false;
    if (!loc1.latitude || !loc1.longitude || !loc2.latitude || !loc2.longitude) return false;
    return loc1.latitude !== loc2.latitude || loc1.longitude !== loc2.longitude;
  };

  // Determine if we should show check-out separately
  const shouldShowCheckOutSeparately = hasCheckOutLocation && 
    (!hasCheckInLocation || areLocationsDifferent(checkInLocation, checkOutLocation));

  return (
    <div className="mt-2">
      <div 
        className="p-2 bg-light rounded cursor-pointer d-flex align-items-center justify-content-between"
        onClick={toggleExpand}
        style={{ cursor: 'pointer' }}
      >
        <div className="d-flex align-items-center gap-2">
          <MapPin size={16} className="text-primary" />
          <div>
            <small className="text-muted">Location</small>
            <div className="d-flex gap-1 mt-1">
              {hasCheckInLocation && (
                <span className="badge bg-success">Check-in</span>
              )}
              {hasCheckOutLocation && shouldShowCheckOutSeparately && (
                <span className="badge bg-danger">Check-out</span>
              )}
              {hasCheckOutLocation && !shouldShowCheckOutSeparately && hasCheckInLocation && (
                <span className="badge bg-warning text-dark">Same Location</span>
              )}
            </div>
          </div>
        </div>
        {isExpanded ? (
          <ChevronDown size={18} className="text-muted" />
        ) : (
          <ChevronRight size={18} className="text-muted" />
        )}
      </div>
      
      {isExpanded && (
        <div className="mt-2">
          {/* Show check-in location if available */}
          {hasCheckInLocation && (
            <SimpleLocationMap
              latitude={checkInLocation!.latitude}
              longitude={checkInLocation!.longitude}
              label={`Check-in${checkInTime ? ` (${checkInTime})` : ''}`}
              showRadius={showRadius}
              radius={radius}
            />
          )}

          {/* Show check-out location ONLY if it exists AND is different from check-in */}
          {shouldShowCheckOutSeparately && (
            <div className="mt-2">
              <SimpleLocationMap
                latitude={checkOutLocation!.latitude}
                longitude={checkOutLocation!.longitude}
                label={`Check-out${checkOutTime ? ` (${checkOutTime})` : ''}`}
                showRadius={showRadius}
                radius={radius}
              />
            </div>
          )}

          {/* Show message if check-in and check-out are at the same location */}
          {hasCheckInLocation && hasCheckOutLocation && !shouldShowCheckOutSeparately && (
            <div className="mt-2 p-2 bg-info bg-opacity-10 rounded border border-info">
              <small className="text-info">
                <MapPin size={12} className="me-1" />
                Check-in and Check-out at the same location
              </small>
            </div>
          )}

          {/* Show message if only check-out exists (no check-in) */}
          {!hasCheckInLocation && hasCheckOutLocation && (
            <div className="mt-2 p-2 bg-warning bg-opacity-10 rounded border border-warning">
              <small className="text-warning">
                <MapPin size={12} className="me-1" />
                Only Check-out location available
              </small>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default LocationSection;